import React, {FC, memo, useCallback, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {Button, Dropdown, DropdownButton, ToggleButton} from "react-bootstrap";
import {PageFilesAction, PageFilesContainer, PageFilesContent} from "./PageFilesStyle";
import Card from "../../component/Card/CardImg";

import {ArrowsMove, Download, FolderPlus, JournalCheck, Trash3, Upload} from "react-bootstrap-icons";
import {actions} from "../../store/sliceApp";
import {actions as actionsModal} from "../../store/sliceModal";
import {actions as actionsFiles, IFile} from "../../store/sliceFiles";
import {useParams} from "react-router-dom";
import {fetchDeleteFiles, fetchFiles, fetchUploadFiles, loadFiles} from "../../fetch/FileRequest";
import CardBack from "../../component/Card/CardBack";
import CardFolder from "../../component/Card/CardFolder";
import CardDefault from "../../component/Card/CardDefault";
import PageNotFound from "../notFound/PageNotFound";
import {IToken} from "../../store/sliceToken";
import {fetchUser} from "../../fetch/AuthRequest";
import moment from "moment";


const PageFiles: FC = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const {id} = useParams()

    const [checked, setChecked] = useState(false)
    // const [delEnable, setDelEnable] = useState(false)

    const [notFound, setNotFound] = useState(false)

    const {fileList, checkedList} = useSelector((state: IRootState) => state.files)

    const token: IToken = useSelector((state: IRootState) => state.token)
    const [auth, setAuth] = useState(false)

    useEffect(() => {
        if (moment().add(2, 'second').isAfter(token.expire)){
            fetchUser().then(response => {
                if (response.status == 200) {
                    setAuth(true)
                }
            })
        } else {
            setAuth(true)
        }
    }, [])


    useEffect(() => {
        dispatch(actions.setFiles())

        if (!auth) {
            return
        }

        if (id == null) {
            fetchFiles()
        } else if (isNaN(Number(id))) {
            setNotFound(true);
        } else {
            fetchFiles(Number(id))
        }
    }, [id, auth])

    // useEffect(() => {
    //
    //     if (fileList.filter((file: IFile) => file.folder && checkedList.includes(file.id)).length > 0) {
    //         setDelEnable(false && checked)
    //     } else if (checkedList.length > 0) {
    //         setDelEnable(true && checked)
    //     } else {
    //         setDelEnable(false)
    //     }
    //
    // }, [checked, checkedList, fileList])

    useEffect(() => {
        if (!checkedList?.length) {
            setChecked(false)
        }
    }, [checkedList])


    const selectFiles = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files != null) {
            const files: FileList = event.target.files;
            const formData = new FormData();
            for (let file in files) {
                formData.append('file', files[file]);
            }
            if (isNaN(Number(id))) {
                loadFiles(undefined, formData)
            } else {
                loadFiles(Number(id), formData)
            }

        }

    }, [id])

    // const deleteFile = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    //         deleteFile(id)
    // },[])

    const createFolder = useCallback((event: React.MouseEvent<HTMLButtonElement> | React.TouchEvent<HTMLButtonElement>) => {
        let folderId: number | null
        if (!isNaN(Number(id))) {
            folderId = Number(id)
        } else {
            folderId = null
        }
        dispatch(actionsModal.showCreateRenameModal({id: folderId, title: "Создать папку"}))
    }, [id])

    const fileListRender = useCallback(() => {

        if (fileList?.length == 0) {
            return <></>
        }

        const listFolder = fileList.filter((file: IFile) => file.folder)
            .map((file: IFile) => <CardFolder checkMode={checked} file={file}/>)


        const listFiles = fileList.filter((file: IFile) => !file.folder).map((file: IFile) => {
            if (['png', 'jpg', 'jpeg', 'gif'].includes(file?.type?.toLowerCase())) {
                return (<Card checkMode={checked} file={file}/>)
            }
            return (<CardDefault checkMode={checked} file={file}/>)
        })
        return [...listFolder, ...listFiles]
    }, [fileList, checked])


    const checkboxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.checked) {
            setChecked(true)
        } else {
            setChecked(false)
            dispatch(actionsFiles.clearChecked())
        }
    }, [])

    const deleteFiles = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        fetchDeleteFiles(checkedList).then(resp => {
            if (resp.status === 204) {
                dispatch(actionsFiles.clearChecked())
                setChecked(false)
            }
        })
    }, [checkedList])
    const uploadFiles = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        fetchUploadFiles(checkedList).then(resp => {
            if (resp.status === 200) {
                dispatch(actionsFiles.clearChecked())
                setChecked(false)
            }
        })
    }, [checkedList])

    const moveFiles = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        dispatch(actionsModal.showMoveModal({title: "Перемещение", file: undefined, ids: checkedList}))
    }, [checkedList])


    if (notFound) {
        return (
            <PageNotFound/>
        )
    }

    if (!auth) {
        return (<></>)
    }

    return (
        <PageFilesContainer as={"section"}>
            <PageFilesAction>
                <div style={{marginRight: "auto"}}>
                    <DropdownButton variant={"outline-secondary"} disabled={!(checked && checkedList.length > 0)} title="Действия">
                        <Dropdown.Item as="button" onClick={deleteFiles} style={{marginBottom: "10px"}}>
                            <Trash3 style={{marginRight: "5px"}}/>
                            Удалить
                        </Dropdown.Item>
                        <Dropdown.Item as="button" onClick={uploadFiles} style={{marginBottom: "10px"}}>
                            <Upload style={{marginRight: "5px"}}/>
                            Выгрузить
                        </Dropdown.Item>
                        <Dropdown.Item as="button"  onClick={moveFiles} style={{marginBottom: "0px"}}>
                            <ArrowsMove style={{marginRight: "5px"}}/>
                            Переместить
                        </Dropdown.Item>
                    </DropdownButton>
                </div>

                {/*<div style={{marginRight: "auto"}}>*/}
                {/*    <Button variant={"outline-danger"} disabled={!delEnable} style={{marginRight: "10px"}}*/}
                {/*            onClick={deleteFiles}> <Trash3*/}
                {/*        style={{marginRight: "5px"}}/>*/}
                {/*        <span>Удалить</span>*/}
                {/*    </Button>*/}
                {/*    <Button variant={"outline-success"} disabled={!(checked && checkedList.length > 0)} onClick={uploadFiles} style={{marginRight: "10px"}}> */}
                {/*        <Upload style={{marginRight: "5px"}}/>*/}
                {/*        <span>Выгрузить</span>*/}
                {/*    </Button>*/}
                {/*    <Button variant={"outline-success"} disabled={!(checked && checkedList.length > 0)} onClick={moveFiles}>*/}
                {/*        <ArrowsMove style={{marginRight: "5px"}}/>*/}
                {/*        <span>Переместить</span>*/}
                {/*    </Button>*/}
                {/*</div>*/}
                <ToggleButton
                    id="toggle-check"
                    type="checkbox"
                    variant="outline-success"
                    checked={checked}
                    value="1"
                    onChange={checkboxChange}
                >
                    <JournalCheck style={{marginRight: "5px"}}/>
                    <span>Выбор</span>
                </ToggleButton>
                <Button variant={"outline-success"} onClick={createFolder}><FolderPlus style={{marginRight: "5px"}}/>
                    <span>Новая папка</span>
                </Button>
                <Button variant={"success"}>

                    <label>
                        <Download style={{marginRight: "5px"}}/>
                        <input type={"file"} multiple hidden={true} onChange={selectFiles}/>
                        <span>Загрузить файлы</span>
                    </label>
                </Button>
            </PageFilesAction>
            <PageFilesContent>
                {id !== undefined &&
                    <CardBack parentId={fileList.length > 0 ? fileList[0]?.parentId : undefined}/>}
                {fileListRender()}
            </PageFilesContent>
        </PageFilesContainer>
    );
}
export default memo(PageFiles);
